<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>
    <router-link v-slot="{ navigate }" :to="{name: 'basket', params: $route.params}" custom>
        <div class="sl-navbar__icon-item relative" @click="navigate">
            <mdi-icon icon="mdiBasket" />
            <div v-if="itemsCount" class="sl-basket__count-wrapper">
                <div class="sl-basket__count">
                    {{ itemsCount }}
                </div>
            </div>
        </div>
    </router-link>
</template>


<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>
export default
{
    name: 'BasketMenu',

    computed:
    {
        itemsCount()
        {
            return this.$store.state.basket.lines.reduce(
                (carry, currentLine) => carry + currentLine.quantity, 0
            );
        },
    },
};
</script>


<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";


.sl-basket__count-wrapper
{
    right: 5px;
    top: 7px;
    width: 18px;
    height: 18px;
    @apply absolute flex items-center justify-center bg-yellow-400 rounded-full;
}

.sl-basket__count
{
    font-size: 0.675rem;
    transform: translateY(1px);
    @apply text-primary-500;
}

</style>
